interface Images {
  largeProduct: string
}

interface Rrp {
  displayValue: string
}

interface LandingPageLink {
  text: string
  url: string
  openExternally: boolean
  noFollow: boolean
}

interface FreeGiftProduct {
  images: Images[]
  title: string
  price: {
    rrp: Rrp
  }
}

export interface MarketedSpecialOfferSummary {
  title: string
  description: string
  landingPageLink?: LandingPageLink | null
  freeGiftProduct?: FreeGiftProduct | null
}

export const productMarketedSpecialOffer = (product: {
  marketedSpecialOffer?: {
    title?: {
      content: {
        content: string
      }[]
    }
    description?: {
      content: {
        content: string
      }[]
    }
    landingPageLink?: {
      text: string
      url: string
      openExternally: boolean
      noFollow: boolean
    }
    freeGiftProduct?: {
      title: string
      price?: {
        rrp: {
          displayValue: string
        }
      }
      images: {
        largeProduct: string
      }
    }
  }
}): MarketedSpecialOfferSummary | null => {
  if (!product?.marketedSpecialOffer) {
    return null
  }

  const marketedSpecialOfferData = product.marketedSpecialOffer

  return {
    title: marketedSpecialOfferData.title?.content[0].content || '',
    description: marketedSpecialOfferData.description?.content[0].content || '',
    landingPageLink: marketedSpecialOfferData.landingPageLink
      ? {
          text: marketedSpecialOfferData.landingPageLink.text,
          url: marketedSpecialOfferData.landingPageLink.url,
          openExternally:
            marketedSpecialOfferData.landingPageLink.openExternally || false,
          noFollow: marketedSpecialOfferData.landingPageLink.noFollow || true,
        }
      : null,
    freeGiftProduct: marketedSpecialOfferData.freeGiftProduct
      ? {
          title: marketedSpecialOfferData.freeGiftProduct.title,
          price: {
            rrp: {
              displayValue:
                marketedSpecialOfferData.freeGiftProduct.price?.rrp
                  .displayValue || '',
            },
          },
          images:
            marketedSpecialOfferData.freeGiftProduct.images.map((image) => ({
              largeProduct: image.largeProduct,
            })) || [],
        }
      : null,
  }
}
